import { forwardRef, Fragment } from 'react';

import { Levels } from '_core/utils/public-links/_types';

import { ExploreDropdownToggle } from '../types';
import { DropdownButton } from './dropdown-button.component';
import { MainLinkItem } from './main-link-item.component';

type Props = {
  category: Levels;
  hideCategory?: boolean;
  isOpenServices?: ExploreDropdownToggle | undefined;
  openDropdown?: (param: string) => void;
  showDropdown?: boolean;
  selectedId?: string;
};

export const LinksSection = forwardRef<HTMLDivElement | HTMLHeadingElement, Props>((props, ref) => {
  const { category, hideCategory, isOpenServices, openDropdown, showDropdown, selectedId } = props;
  return (
    <Fragment>
      {Object.keys(category).map((levelOne, key) => {
        const categories = Object.keys(category[levelOne]);
        return (
          <Fragment key={`${levelOne}-${key}`}>
            {levelOne !== 'null' && !hideCategory && (
              <h3 className="h5 bold mb-5 mt-8" id={levelOne} ref={ref}>
                {levelOne}
              </h3>
            )}
            {categories.map((levelTwo, key) => {
              const cities = Object.keys(category[levelOne][levelTwo]);
              const shouldShowDropdownLinks =
                ((levelTwo === selectedId && isOpenServices?.[levelTwo]) || isOpenServices?.[levelTwo]) ?? true;

              return (
                <Fragment key={`dropdown-${category}-${levelOne}-${levelOne}-${key}`}>
                  {showDropdown && levelTwo !== 'null' ? (
                    <DropdownButton
                      className="mb-2 width-100"
                      id={levelTwo}
                      label={levelTwo}
                      openDropdown={openDropdown}
                      isOpenServices={isOpenServices}
                      ref={ref}>
                      <MainLinkItem
                        category={category}
                        levelOne={levelOne}
                        levelTwo={levelTwo}
                        cities={cities}
                        variant="default"
                        shouldShowDropdownLinks={shouldShowDropdownLinks}
                      />
                    </DropdownButton>
                  ) : (
                    <Fragment>
                      {levelTwo !== 'null' && <h4>{levelTwo}</h4>}
                      <MainLinkItem
                        category={category}
                        levelOne={levelOne}
                        levelTwo={levelTwo}
                        cities={cities}
                        variant="default"
                        shouldShowDropdownLinks={shouldShowDropdownLinks}
                      />
                    </Fragment>
                  )}
                </Fragment>
              );
            })}
          </Fragment>
        );
      })}
    </Fragment>
  );
});
